import { register } from "register-service-worker";

register("/service-worker.js", {
  registrationOptions: { scope: "./" },
  ready() {
    console.log("Service worker is active.");
  },
  registered() {
    console.log("Service worker has been registered.");
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New content is downloading.");
  },
  updated(registration) {
    console.log("New content is available; please refresh.");
    document.dispatchEvent(
      new CustomEvent("swUpdated", { detail: registration })
    );
  },
  offline() {
    console.log(
      "No internet connection found. App is running in offline mode."
    );
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  },
});
// import { Workbox } from "workbox-window";

// let wb;

// if ("serviceWorker" in navigator) {
//   wb = new Workbox(`${process.env.BASE_URL}service-worker.js`);

//   wb.addEventListener("controlling", () => {
//     window.location.reload();
//   });

//   wb.register();
// } else {
//   wb = null;
// }

// export default wb;
